module.exports = __webpack_public_path__ + "img/image-light.f3e95706.svg";